import { css, Dropdown, Grid, MAGNETIC_TOKENS, Icon } from '@appd/uik';
import { useState } from 'react';

const { Option } = Dropdown;

export type FiltersListColumns = {
  varName: string;
};

export type CellRendererProps<T, V = string> = {
  data: T;
  value: V;
};

const { SPACING } = MAGNETIC_TOKENS;

export const FiltersDrawer = ({ vars, onSelectFilter }: any): JSX.Element => {
  const [gridApi, setGridApi] = useState<Grid.GridApi>();

  const onGridReady: Grid.Props['onGridReady'] = ({ api }) => setGridApi(api);

  const filterDrawerCellRenderer = (props: CellRendererProps<FiltersListColumns>) => (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
        <div>{props.value}</div>
        <Dropdown data-testid="filter-edit-menu" icon={'Navigation.MoreHorizontal'} kind="TERTIARY">
          <div className="flex flex-row items-center">
            <Icon.Action.Edit size="MEDIUM" style={{ paddingLeft: 12 }} />
            <Option key={props.value} onClick={onClick}>
              Edit
            </Option>
          </div>
        </Dropdown>
      </div>
    </>
  );

  const columnsToBeShown = [
    {
      field: 'varName',
      headerTooltip: 'Name',
      headerName: 'Variables',
      cellRenderer: filterDrawerCellRenderer,
      sortable: false,
    },
  ];

  const onClick = () => {
    const selectedNodes = gridApi?.getSelectedRows() ?? [''];
    onSelectFilter(vars.findIndex((item: FiltersListColumns) => item.varName === selectedNodes[0]?.varName ?? ''));
  };

  return (
    <div data-testid="filters-drawer" key="filtersDrawer" className="flex flex-col h-full gap-4">
      <Grid<FiltersListColumns, any>
        data-testid="uik-grid"
        className={css({ height: '73vh' })}
        columns={columnsToBeShown}
        onGridReady={onGridReady}
        rows={vars}
        rowSelection="single"
      />
    </div>
  );
};
